<template>
  <section class="home-section-photo">
    <router-link :to="`/article/${item.id}`">
      <img v-if="item.img" :src="item.img" :alt="item.title">
      <h4>{{ item.title }}</h4>
      <p>{{ item.description }}</p>
    </router-link>
  </section>
</template>
<script>
export default {
  name: 'mLongListArticleItem',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
